'use strict';

angular.module('mean.trades').controller('TradeBidRequestEditController', ['$scope', 'MeanUser', 'Global', 'Bids', '$filter', 'Units', '$q', 'toaster', 'NotifyService', 'BidRequestEdit', '$location', 'Materials', 'Equipments', 'BidMaterialsSaves', 'tradeCodeService', 'taskTotalsService', 'Trades', 'userService', 'Subtasks', 'TradeBids', 'ngDialog', 'bidTotalsService', 'bidRequestEditService', 'tradeService', 'TradeItems', 'bidProposalPrintService', '$loading',
  function($scope, MeanUser, Global, Bids, $filter, Units, $q, toaster, NotifyService, BidRequestEdit, $location, Materials, Equipments, BidMaterialsSaves, tradeCodeService, taskTotalsService, Trades, userService, Subtasks, TradeBids, ngDialog, bidTotalsService, bidRequestEditService, tradeService, TradeItems, bidProposalPrintService, $loading) {
    $scope.global = Global;

    $scope.user = MeanUser.user;
    $scope.selectionOption = 'plan';

    $scope.show_spinner = false;

    $scope.expanded_table = 'true';
    $scope.bid_total_labor = 0;
    $scope.bid_total_materials = 0;
    $scope.bid_total_equipment = 0;
    $scope.bid_total = 0;
    $scope.bid_general_liability = 0;
    $scope.available_materials = [];
    $scope.available_categories = [];
    $scope.available_equipments = [];
    $scope.available_equipment_categories = [];
    $scope.available_subtask_categories = [];
    $scope.trade_subtasks = [];
    $scope.bid_menu = [];
    $scope.my_inclusions = [];
    $scope.my_exclusions = [];
    $scope.my_proposals = [];
    $scope.materialEditId = 0;
    $scope.equipmentEditId = 0;
    $scope.editId = -1;
    $scope.editSub = -1;
    $scope.shortcuts = [];
    $scope.materials = [];
    $scope.plans = [];
    $scope.override_supplier = {'name': 'All'};

    $scope.editSpecText = '';
    $scope.editSpecHeader = '';
    $scope.editSpecIndex = 0;

    $scope.sortType = ['task', 'plan_code', 'name', 'note'];
    $scope.sortReverse = false;
    $scope.defaultMaterialType = 'All';
    var data = [];

    $scope.subSelection = [];
    $scope.has_one = false;
    $scope.has_many = false;
    $scope.subChangeEvent = false;
    $scope.main_account_id = null;

    $scope.print_options = {
        showHeaderInfo: true,
        showOwnerInfo: true,
        showContractorInfo: true,
        showProposalInfo: true,
        showCostInfo: true,
        showTermsInfo: true,
        showInclusionsInfo: true,
        showExclusionsInfo: true,
        showSignatureInfo: true,
        showPageBreak: false
    }

    $scope.example15settings = {
        buttonClasses: 'form-control',
        externalIdProp: '',
        enableSearch: false,
        smartButtonMaxItems: 1,
        smartButtonTextConverter: function(itemText, originalItem) {
            if($scope.subSelection.length > 1) {
                return $scope.subSelection.length + ' checked'
            } else {
                return itemText;
            }
        }
    };

    $scope.example5customTexts = {
        buttonDefaultText: 'Subtasks'
    };
console.log('TradeBidRequestEditController');
    $scope.selectionEvents = function() {
        if(!this.task.available_subtasks) {
            this.task.available_subtasks = [];
            var subtasks = $filter('filter')($scope.my_trade.subtasks,{
                'task': this.task.task,
                'projectType': $scope.my_bid.projectType || $scope.bid.projectType,
                'geoLocation': $scope.my_bid.geoLocation || $scope.bid.geoLocation
            }, true);
            subtasks = $filter('orderBy')(subtasks, 'name');

            var available_subtasks = this.task.available_subtasks;
            _.each(subtasks, function(sub, idx) {
                available_subtasks.push({
                    id: idx,
                    _id: sub._id,
                    label: sub.name,
                    category: sub.category
                });
            });
        }

        if(!this.task.subSelection) {
            this.task.subSelection = [];
            this.task.has_one = false;
            this.task.has_many = false;
        }

        if(this.task.subSelection.length === 0) {
            if(this.task.has_one) {
                this.task.has_one = false;
                this.task.has_many = false;
                this.task.selectedSub = {};
            }
            return;
        }

        if(this.task.subSelection.length === 1) {
            this.task.has_many = false;
            this.task.selectedSub = this.task.subSelection[0];
        } else {
            this.task.has_one = false;
            this.task.has_many = true;
            return;
        }

        this.task.has_one = true;
    };

    Units.query({}, function(units) {
        $scope.units = units
    });

    $scope.$on('showBidRequestSpinnerOn', function(event, data) {
        console.log('showBidRequestSpinnerOn')
        $scope.show_spinner = true;
    });

    $scope.$on('showBidRequestSpinnerOff', function(event, data) {
        console.log('showBidRequestSpinnerOff')
        $scope.show_spinner = false;
    });

    $scope.$on('updatedTradeBid', function(event, data) {
        $scope.show_spinner = true;
        $scope.my_bid = data;
        if(!$scope.my_bid.submitted_by) {
            $scope.my_bid.submitted_by = $scope.user.name;
        }
        //$scope.my_bid.overrides = []; //this action removes overrides by the user

        $scope.saveToDatabase();
    });

    $scope.$on('updatedTradeTasks', function(event, data) {
        $scope.show_spinner = true;
        $scope.my_bid = data;
        if(!$scope.my_bid.submitted_by) {
            $scope.my_bid.submitted_by = $scope.user.name;
        }
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        $scope.saveToDatabase();
    });

    $scope.viewDetails = function(type, index, text) {
        //this function gets called when the spec modal is active
        //and sets some global variables for the edit functions
        $scope.editSpecIndex = index;
        if(type == 0) {
            $scope.editSpecHeader = 'Inclusion Edit';
        } else if(type == 1) {
            $scope.editSpecHeader = 'Exclusion Edit';
        } else if(type == 3) {
            $scope.editSpecHeader = 'Proposal Edit';
        } else if(type == 4) {
            $scope.editSpecHeader = 'Signature Edit';
        }

        $scope.editSpecText = text;
    };

    $scope.isMatOrEq = function() {
        if(!$scope.current_plan) return false;

        return $scope.current_plan.item === 'Materials' || $scope.current_plan.item === 'Equipment' || $scope.current_plan.item === 'Labor' || $scope.current_plan.item === 'Trade Rates' || $scope.current_plan.item === 'Shortcuts' || $scope.current_plan.item === 'Total Materials'
    };

    $scope.acceptEditSpec = function() {
        $scope.editSpecText = this.editSpecText;
        if($scope.editSpecHeader === 'Inclusion Edit') {
            $scope.my_bid.inclusions[$scope.editSpecIndex] = $scope.editSpecText;
            $scope.my_inclusions = $scope.my_bid.inclusions;
        } else if($scope.editSpecHeader === 'Exclusion Edit'){
            $scope.my_bid.exclusions[$scope.editSpecIndex] = $scope.editSpecText;
            $scope.my_exclusions = $scope.my_bid.exclusions;
        } else if($scope.editSpecHeader === 'Proposals Edit'){
            $scope.my_bid.proposals[$scope.editSpecIndex] = $scope.editSpecText;
            $scope.my_proposals = $scope.my_bid.proposals;
        } else if($scope.editSpecHeader === 'Signatures Edit'){
            $scope.my_bid.signatures[$scope.editSpecIndex] = $scope.editSpecText;
            $scope.my_signatures = $scope.my_bid.signatures;
        }

        $scope.my_bid.$update();
    };

    $scope.cancelEditSpec = function() {
        if($scope.editSpecHeader === 'Inclusion Edit') {
            $scope.my_inclusions = $scope.my_bid.inclusions;
        } else {
            $scope.my_exclusions = $scope.my_bid.exclusions;
        }
    };

    $scope.deleteSpec = function() {
        if($scope.editSpecHeader === 'Inclusion Edit') {
            $scope.my_bid.inclusions.splice($scope.editSpecIndex, 1);
            $scope.my_inclusions = $scope.my_bid.inclusions;
        } else {
            $scope.my_bid.exclusions.splice($scope.editSpecIndex, 1);
            $scope.my_exclusions = $scope.my_bid.exclusions;
        }
        $scope.my_bid.$update();
    };

    $scope.addProposal = function() {
        $scope.my_bid.proposals.push(this.newProposal);
        $scope.my_proposals = $scope.my_bid.proposals;
        $scope.updateTradeBid();

        this.newProposal = '';
    };

    $scope.addInclusion = function() {
        $scope.my_bid.inclusions.push(this.newInclusion);
        $scope.my_inclusions = $scope.my_bid.inclusions;
        $scope.updateTradeBid();

        this.newInclusion = '';
    };

    $scope.addExclusion = function() {
        $scope.my_bid.exclusions.push(this.newExclusion);
        $scope.my_exclusions = $scope.my_bid.exclusions;
        $scope.updateTradeBid();

        this.newExclusion = '';
    };

    $scope.toggleTableColumns = function() {
        if($scope.expanded_table === 'true') {
            $scope.expanded_table = 'false';
        } else {
            $scope.expanded_table = 'true';
        }
    };

    $scope.init = function() {
        $scope.expanded_table = 'false';
        $scope.bid = BidRequestEdit.get();

        if(!$scope.bid || !$scope.bid._id){
            $location.path('home');
            return;
        }

        $scope.bid.project_start_date = new Date($scope.bid.project_start_date);

        $scope.bid_menu.push({
            item: 'Labor'
        });

        $scope.bid_menu.push({
            item: 'Materials'
        });

        $scope.bid_menu.push({
            item: 'Equipment'
        });

        $scope.bid_menu.push({
            item: 'Shortcuts'
        });

        // if($scope.bid.plan_codes.length == 0) {
        //     var codes = [];
        //     if($scope.bid.project_plan.single) {
        //         $scope.bid.project_plan.single.forEach(function (single) {
        //             console.log(single);
        //             if(single.elevations) {
        //                 var qty = (single.quantity)?single.quantity:0;
        //                 var array = single.elevations.split(',');
        //                 if(array.length > 1) {
        //                     array.forEach(function (arr_itm) {
        //                         codes.push({
        //                             code: single.number + arr_itm.trim(),
        //                             quantity: qty
        //                         })
        //                     })
        //                 } else {
        //                     codes.push({
        //                         code: single.number + single.elevations,
        //                         quantity: qty
        //                     })
        //                 }
        //             }
        //         });
        //     }
        //     $scope.bid.plan_codes = codes;
        //     //$scope.bid.save(function (err) { });
        // }
        
        _.each($scope.bid.plan_codes, function(item) {
            $scope.bid_menu.push({
                item: item.code,
                notes: item.notes
            });

            $scope.plans.push({
                item: item.code,
                notes: item.notes
            });
        });

        $scope.bid_menu.push({
            item: 'Cover'
        });

        $scope.bid_menu.push({
            item: 'Proposal'
        });

        $scope.bid_menu.push({
            item: 'Trade Rates'
        });

        $scope.bid_menu.push({
            item: 'Total Materials'
        });

        $scope.current_plan = $scope.bid_menu[0];
        $scope.main_bid_menu = $scope.bid_menu;

        $scope.user = MeanUser.user;
        $scope.my_bid_trade = $scope.getTradeCode($scope.user.trade[0]);

        userService.getMainAccount($scope.user.username).then(function(main_user) {
            $scope.main_account_id = main_user._id;
            TradeBids.query({'bid_id': $scope.bid._id, 'username': main_user.username}, function(trade_bid) {
                $scope.my_bid = trade_bid[0];

                if(!$scope.my_bid.submitted_by) {
                    $scope.my_bid.submitted_by = $scope.user.name;
                }

                Trades.query({'main_account_id': main_user._id}, function(trade) {
                    if(trade.length !== 1) return;

                    $scope.my_trade = trade[0];

                    $scope.trade_code = tradeCodeService.getCode($scope.user.trade[0]);
                    userService.getCompanyCode($scope.user.username);

                    TradeItems.query({
                        'company_code': userService.getCompanyCode($scope.user.username),
                        'trade_code': $scope.trade_code,
                        'bid_id': $scope.bid._id }, function(tradeItems) {
                        if(tradeItems.length === 0) {
                            $scope.tradeItems = {
                                hours_allowed: true,
                                crew_rate: true,
                                trade_rates: true,
                                labor_costs: true,
                                liability: true,
                                markup: true,
                                material_costs: true,
                                equipment_costs: true,
                                quantity: true
                            }
                        } else if(tradeItems.length === 1) {
                            $scope.tradeItems = tradeItems[0];
                        } else {
                            toaster.pop('error', 'Trade Items Error', 'Contact Admin');
                            return;
                        }
                    });

                        //this is the first time we're processing this bid
                        //we need to get some input from the user first
                        //$scope.trade_code = tradeCodeService.getCode($scope.user.trade[0]);
                        $scope.available_material_suppliers = [];
                        $scope.available_equipment_suppliers = [];

                        Materials.query({
                            'type':'MaterialFilter',
                            'supplier': true,
                            'trade_account': $scope.my_trade._id,
                            //'isInventory': 'All',
                            'userId': $scope.main_account_id
                         }, function(items) {
                            $scope.available_material_suppliers = items;
                        });

                        Equipments.query({ 'trade_account': $scope.my_trade._id, 'get_suppliers': 1 }, function(items) {
                            $scope.available_equipment_suppliers = items;
                        });

                    if($scope.my_bid.first_process) {
                        ngDialog.open({
                            template: 'trades/views/first-bid-request-edit-popup.html',
                            scope: $scope,
                            controller: 'TradeFirstBidRequestController',
                            className: 'ngdialog-theme-default'
                        });
                    }

                    $scope.my_inclusions = $scope.my_bid.inclusions;
                    $scope.my_exclusions = $scope.my_bid.exclusions;
                    $scope.my_proposals = $scope.my_bid.proposals;

                    if(!$scope.my_bid.first_process) {
                        $scope.getMaterial();
                        $scope.getEquipment();
                    }

                    //this pulls rates from the trade if it does not
                    //yet exist in the bid.
                    if(!$scope.my_bid.costs) {
                        $scope.my_bid.costs = $scope.company_factors = trade[0].costs;
                    } else {
                        $scope.company_factors = $scope.my_bid.costs;
                    }


                    var tradeSubtask = $filter('filter')($scope.my_trade.subtasks, {
                        'trade': $scope.my_bid_trade,
                        'projectType': $scope.bid.projectType,
                        'geoLocation': $scope.bid.geoLocation
                     }, true);

                    $scope.trade_subtasks = tradeSubtask;

                    _.each($scope.trade_subtasks, function(subtask) {
                        var inlist = $filter('filter')($scope.available_subtask_categories, {
                            'category': subtask.category, 'code': subtask.code }, true);
                        if(inlist.length === 0) {
                            $scope.available_subtask_categories.push({
                                code: subtask.code,
                                category: subtask.category
                            });
                        }
                    });
                });
            });
        });
        //});
    };

    $scope.changeCategory = function(task) {
        task.available_subtasks = [];

        if(!this.current_category) {
            for(var i=0; i<$scope.trade_subtasks.length; i++) {
                if($scope.trade_subtasks[i].task === task.task) {

                    task.available_subtasks.push({
                        id: i,
                        _id: $scope.trade_subtasks[i]._id,
                        label: $scope.trade_subtasks[i].name,
                        category: $scope.trade_subtasks[i].category
                    });
                }
            }
        } else {
            var subtasks = $filter('filter')($scope.trade_subtasks, {
                'category': this.current_category.category,
                'code': this.current_category.code,
                'projectType': $scope.bid.projectType,
                'geoLocation': $scope.bid.geoLocation
            }, true);

            if(!subtasks) return;

            for(var i=0; i<subtasks.length; i++) {
                if(subtasks[i].task === task.task) {
                    task.available_subtasks.push({
                        id: i,
                        _id: subtasks[i]._id,
                        label: subtasks[i].name,
                        category: subtasks[i].category
                    });
                }
            }
        }
    };

    $scope.editOptions = function() {
        BidRequestEdit.set($scope.bid);
    };

    $scope.setMaterialSupplier = function() {
        $scope.my_bid.supplier = $scope.material_supplier;
        $scope.updateTradeBid();
        $scope.getMaterial();
    };

    $scope.setEquipmentSupplier = function() {
        $scope.my_bid.equipment_supplier = $scope.equipment_supplier;
        $scope.updateTradeBid();
        $scope.getEquipment();
    };

    $scope.getMaterial = function() {
        $scope.material_supplier = $scope.my_bid.supplier;

        Materials.query({
            'trade_account': $scope.my_trade._id ,
            'supplier': $scope.my_bid.supplier,
            'userId': $scope.main_account_id
        }, function(materials) {
            $scope.available_materials = materials;
            $scope.available_materials.forEach(function(material, idx) {

                var in_list = $filter('filter')($scope.available_categories, {name: material.category}, true);
                if(in_list.length === 0) {
                    $scope.available_categories.push({
                        name: material.category
                    });
                }
            });
        });
    }

    $scope.getEquipment = function() {
        $scope.equipment_supplier = $scope.my_bid.equipment_supplier;

        Equipments.query({ 'trade_account': $scope.my_trade._id , supplier: $scope.my_bid.equipment_supplier}, function(equipments) {
            $scope.available_equipments = equipments;
            $scope.available_equipments.forEach(function(equipment, idx) {

                var in_list = $filter('filter')($scope.available_equipment_categories, {name: equipment.category}, true);
                if(in_list.length === 0) {
                    $scope.available_equipment_categories.push({
                        name: equipment.category
                    });
                }
            });
        });
    };

    $scope.supplierModalActivated = function(task_id, index, subtask_idx) {
        $scope.override_task_id = task_id;
        $scope.override_index = index;
        $scope.override_subtask_idx = subtask_idx;

        if(!$scope.available_suppliers) {
            $scope.available_suppliers = [];

            Materials.query({
                'trade_account': $scope.my_trade._id,
                'userId': $scope.main_account_id
             }, function(materials) {
                $scope.all_materials = materials;
                // $scope.all_materials.forEach(function(material, idx) {

                //   if(material.isInventory == $scope.defaultMaterialType){
                //         var in_list = $filter('filter')($scope.available_suppliers, {name: material.supplier}, true);
                //         if(in_list.length === 0) {
                //             $scope.available_suppliers.push({
                //                 name: material.supplier
                //             });
                //         }
                //   }
                // });
                $scope.onMaterialTypeSelect($scope.defaultMaterialType);
            });
        }
    };

    $scope.equipmentSupplierModalActivated = function(task_id, index, subtask_idx) {
        $scope.override_task_id = task_id;
        $scope.override_index = index;
        $scope.override_subtask_idx = subtask_idx;

        if(!$scope.all_equipments) {
            $scope.all_equipments = [];
            $scope.available_equipment_suppliers = [];

            Equipments.query({ 'trade_account': $scope.my_trade._id }, function(equipments) {
                $scope.all_equipments = equipments;
                $scope.all_equipments.forEach(function(equipment, idx) {

                    var in_list = $filter('filter')($scope.available_equipment_suppliers, {name: equipment.supplier}, true);
                    if(in_list.length === 0) {
                        $scope.available_equipment_suppliers.push({
                            name: equipment.supplier
                        });
                    }
                });
            });
        }
    };

    $scope.onMaterialTypeSelect = (isInventory)=>{
        var query = {
            'trade_account': $scope.my_trade._id,
            'type':'MaterialFilter',
            //'isInventory':isInventory,
            'supplier':true,
            'userId': $scope.main_account_id
        }

        if(isInventory == 'From Inventory') {
            query.isInventory = true;
        } else if(isInventory == 'From Supplier') {
            query.isInventory = false;
        }

        Materials.query(query, (supplier) => {
            $scope.available_suppliers = [];
            supplier.forEach(e=>{
                $scope.available_suppliers.push({name: e});
            });
            $scope.available_suppliers.unshift({name: 'All'});

            $scope.override_supplier = $scope.available_suppliers[0];
            $scope.onSupplierSelect($scope.available_suppliers[0], isInventory);
        });
    };

    $scope.onSupplierSelect = function(new_supplier, isInventory = 'All') {

        if(isInventory != 'All') {
            var invParams = (isInventory == 'From Inventory' ? true : false);
            var queryFilter = { 'isInventory':  invParams  };

            if(new_supplier.name != 'All')
                (new_supplier) && (queryFilter['supplier'] = new_supplier.name);

            $scope.overridden_materials = $filter('filter')($scope.all_materials, queryFilter , true);
        } else {
            $scope.overridden_materials = $scope.all_materials;
        }

        $scope.overridden_categories = [];
        $scope.overridden_materials = $filter('orderBy')($scope.overridden_materials, 'name');

        $scope.overridden_materials.forEach(function(material, idx) {
            var in_list = $filter('filter')($scope.overridden_categories, {name: material.category}, true);
            if(in_list.length === 0) {
                $scope.overridden_categories.push({
                    name: material.category
                });
            }
        });
        $scope.overridden_categories.unshift({name: 'All'});
        $scope.override_category = $scope.overridden_categories[0];
    };

    $scope.onEquipmentSupplierSelect = function(new_supplier) {
        $scope.overridden_equipments = $filter('filter')($scope.all_equipments, { supplier: new_supplier.name }, true);
        $scope.overridden_equipment_categories = [];

        $scope.overridden_equipments = $filter('orderBy')($scope.overridden_equipments, 'name');

        $scope.overridden_equipments.forEach(function(equipment, idx) {
            var in_list = $filter('filter')($scope.overridden_equipment_categories, {name: equipment.category}, true);
            if(in_list.length === 0) {
                $scope.overridden_equipment_categories.push({
                    name: equipment.category
                });
            }
        });
    };

    $scope.addAllSubtasks = function(task) {
        if($scope.my_bid.bid.length > 0) {
            toaster.pop('warning', 'Bid Data', 'You cannot add a subtask once bid information has been created');
            this.selected_subtask = '';
            return;
        }
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        var subs = $filter('filter')($scope.trade_subtasks,{
            'task': task.task,
            'projectType': $scope.my_bid.projectType || $scope.bid.projectType,
            'geoLocation': $scope.my_bid.geoLocation || $scope.bid.geoLocation
        }, true);

        task.subtasks = subs;

        for(var i=0; i<task.subtasks.length; i++) {
            task.subtasks[i]._id = i;
        }

        $scope.$broadcast('updateSubtaskShortcuts', $scope.my_bid);
    };

    $scope.addSelectedSubtasks = function(task, selected_subtasks) {
        if($scope.my_bid.bid.length > 0) {
            toaster.pop('warning', 'Bid Data', 'You cannot add a subtask once bid information has been created');
            this.selected_subtask = '';
            return;
        }

        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        _.each(selected_subtasks, function(sub) {
            $scope.addSubtask(task, sub);
        });

        this.selected_subtasks = [];
        this.current_category = '';
        $scope.$broadcast('updateSubtaskShortcuts', $scope.my_bid);
    };

    $scope.addSubtask = function(task, sub) {
        //sub is the system subtask but we need to see if we have an
        //overridden subtask in our tradeBid.
        var inlist = $filter('filter')($scope.my_trade.subtasks, {'_id': sub._id}, true);

        if(inlist.length === 1) {
            var time = new Date().getTime();
            _.each(inlist[0].materials, function(mat, idx) {
                mat._id = time + idx;
            });

            task.subtasks.push({
                _id: task.subtasks.length,
                code: inlist[0].code,
                trade: inlist[0].trade,
                task: inlist[0].task,
                name: inlist[0].name,
                unit: inlist[0].unit,
                materials: inlist[0].materials,
                subtask_id: inlist[0].subtask_id,
                piece_rate: inlist[0].piece_rate,
                crew_rate: inlist[0].crew_rate,
                piece_per_hour_rate: inlist[0].piece_per_hour_rate
            });
        } else {
            toaster.pop('error', 'Add Subtask Error', 'This should not happen.  Conatact Admin');
            // task.subtasks.push({
            //     _id: task.subtasks.length,
            //     code: sub.code,
            //     trade: sub.trade,
            //     task: sub.task,
            //     name: sub.name,
            //     unit: sub.unit,
            //     subtask_id: sub._id,
            //     piece_rate: sub.piece_rate,
            //     crew_rate: sub.crew_rate,
            //     piece_per_hour_rate: sub.piece_per_hour_rate
            // });
        }

        task.subtasks  = $filter('orderBy')(task.subtasks, 'name');

        //this will reset all the _id's but we probably need
        //a check to see if there is an associated bid
        _.each(task.subtasks, function(sub, i) {
            sub._id = i;
        });
    };

    $scope.removeSubtask = function(task, subtask) {
        if($scope.my_bid.bid.length > 0) {
            toaster.pop('warning', 'Bid Data', 'You cannot remove a subtask once bid information has been created');
            return;
        }

        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        var idx = task.subtasks.indexOf(subtask);

        if(idx === -1) {
            toaster.pop('error', 'Subtask Problem', 'Could not get subtask.  Contact Admin');
            return;
        }
        //before we remove the subtask we need to check
        //the bid list and see if there is a bid and remove it
        if($scope.my_bid.bid.length) {
            var inlist = $filter('filter')($scope.my_bid.bid, {'task_id': task._id}, true);

            if(inlist.length) {
                //we have at least one bid task and maybe multiple
                for(var i=0; i<inlist.length; i++) {
                    if(inlist[i].subtasks[idx]) {
                        inlist[i].subtasks.splice(idx, 1);

                        for(var j=0; j<inlist[i].subtasks.length; j++) {
                            inlist[i].subtasks[j].task_id = j;
                        }
                    }
                }
            }
        }

        task.subtasks.splice(idx, 1);

        //this will reset all the _id's but we probably need
        //a check to see if there is an associated bid
        for(var i=0; i<task.subtasks.length; i++) {
            task.subtasks[i]._id = i;
        }

        $scope.$broadcast('updateSubtaskShortcuts', $scope.my_bid);
    };

    $scope.deleteBidData = function() {
        $scope.my_bid.bid = [];
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];
        $scope.$broadcast('updateSubtaskShortcuts', $scope.my_bid);
    };

    $scope.updateLaborRates = function() {
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        tradeService.updateLaborRates(
            $scope.my_bid.task_list,
            $scope.my_trade.subtasks,
            $scope.my_bid_trade);

        $scope.show_spinner = true;
        $scope.my_bid.$update(function(results) {
            $scope.my_bid = results;
            $scope.show_spinner = false;
            toaster.pop('success', 'Task List Update', 'Database updated');
        }, function(error) {
            toaster.pop('error', 'Task List Update', error);
        });
    };

    $scope.updateLaborRatesOperation = function() {
        ngDialog.openConfirm({
            template:
                '<h2>Update Labor Rates Confirm</h2>' +
                '<p>This operation will update all subtask labor information from the company General Info Center and overwrite any information added to this point.</p>' +
                '<p><br><t><strong>Do you wish to continue?</strong></p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            // perform delete operation
            $scope.updateLaborRates();
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };

    $scope.updateMaterialRates = function() {
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        if(!$scope.all_materials) {
            Materials.query({
                'trade_account': $scope.my_trade._id,
                'userId': $scope.main_account_id
            }, function(materials) {
                $scope.all_materials = materials;

                tradeService.updateMaterialRates(
                $scope.my_bid.task_list,
                $scope.all_materials,
                $scope.my_bid_trade);

                $scope.show_spinner = true;
                $scope.my_bid.$update(function(results) {
                    $scope.my_bid = results;
                    $scope.show_spinner = false;
                    toaster.pop('success', 'Task List Update', 'Database updated');
                }, function(error) {
                    toaster.pop('error', 'Task List Update', error);
                });
            });
        } else {
            tradeService.updateMaterialRates(
                $scope.my_bid.task_list,
                $scope.all_materials,
                $scope.my_bid_trade);

            $scope.show_spinner = true;
            $scope.my_bid.$update(function(results) {
                $scope.my_bid = results;
                $scope.show_spinner = false;
                toaster.pop('success', 'Task List Update', 'Database updated');
            }, function(error) {
                toaster.pop('error', 'Task List Update', error);
            });
        }
    };

    $scope.updateMaterialRatesOperation = function() {
        ngDialog.openConfirm({
            template:
                '<h2>Update Material Rates Confirm</h2>' +
                '<p>This operation will update all subtask material information from the company General Info Center and overwrite any information added to this point.</p>' +
                '<p><br><t><strong>Do you wish to continue?</strong></p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            // perform delete operation
            $scope.updateMaterialRates();
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };

    $scope.updateEquipmentRates = function() {
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        if(!$scope.all_equipments) {
            Equipments.query({ 'trade_account': $scope.my_trade._id }, function(equipment) {
                $scope.all_equipments = equipment;

                tradeService.updateEquipmentRates(
                $scope.my_bid.task_list,
                $scope.all_equipments,
                $scope.my_bid_trade);

                $scope.show_spinner = true;
                $scope.my_bid.$update(function(results) {
                    $scope.my_bid = results;
                    $scope.show_spinner = false;
                    toaster.pop('success', 'Task List Update', 'Database updated');
                }, function(error) {
                    toaster.pop('error', 'Task List Update', error);
                });
            });
        } else {
            tradeService.updateEquipmentRates(
                $scope.my_bid.task_list,
                $scope.all_equipments,
                $scope.my_bid_trade);

            $scope.show_spinner = true;
            $scope.my_bid.$update(function(results) {
                $scope.my_bid = results;
                $scope.show_spinner = false;
                toaster.pop('success', 'Task List Update', 'Database updated');
            }, function(error) {
                toaster.pop('error', 'Task List Update', error);
            });
        }
    };

    $scope.updateEquipmentRatesOperation = function() {
        ngDialog.openConfirm({
            template:
                '<h2>Update Equipment Rates Confirm</h2>' +
                '<p>This operation will update all subtask equipment information from the company General Info Center and overwrite any information added to this point.</p>' +
                '<p><br><t><strong>Do you wish to continue?</strong></p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            // perform delete operation
            $scope.updateMaterialRates();
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };

    $scope.clearMaterials = function() {
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];
        tradeService.clearMaterials($scope.my_bid.task_list, $scope.my_bid_trade)

        $scope.show_spinner = true;
        $scope.my_bid.$update(function(results) {
            $scope.my_bid = results;
            $scope.show_spinner = false;
            toaster.pop('success', 'Task List Update', 'Database updated');
        }, function(error) {
            toaster.pop('error', 'Task List Update', error);
        });
    };

    $scope.clearMaterialsOperation = function() {
        ngDialog.openConfirm({
            template:
                '<h2>Clear Materials Confirm</h2>' +
                '<p>This operation will remove the materials from the bid.</p>' +
                '<p><br><t><strong>Do you wish to continue?</strong></p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            // perform delete operation
            $scope.clearMaterials();
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };

    $scope.submitTradeBid = function() {
        $scope.my_bid.submitted = 'true';
        $scope.my_bid.date_completed = new Date();

        if(!$scope.my_bid.costs)
            $scope.my_bid.costs = $scope.company_factors;

        //this will update the computed quantity of materials
        for(var i=0; i<$scope.my_bid.bid.length; i++) {
            var task = $filter('filter')($scope.my_bid.task_list, {
                    '_id': $scope.my_bid.bid[i].task_id}, true);

            if(task.length !== 1) {
                toaster.pop('error', 'Task Compute', 'Issue computing bid total. Contact Admin.');
                return;
            }

            for(var j=0; j<$scope.my_bid.bid[i].subtasks.length; j++) {
                var sub = $filter('filter')(task[0].subtasks, {
                    '_id': $scope.my_bid.bid[i].subtasks[j].task_id}, true);

                if(sub.length !== 1) {
                    toaster.pop('error', 'Task Compute', 'Issue computing bid total. Contact Admin.');
                    return;
                }
                //need to compute bid_hours here
                sub[0].quantity = $scope.my_bid.bid[i].subtasks[j].quantity;
                //sub[0].bid_hours = $scope.my_bid.bid[i].subtasks[j].bid_hours;
                //$scope.my_bid.bid[i].subtasks[j].bid_hours =
                //    $scope.getHoursAllowedForItem(sub[0]) * 1;
                //now we need to compute quantities here for materials
                for(var k=0; k<$scope.my_bid.bid[i].subtasks[j].materials.length; k++) {
                    if($scope.my_bid.bid[i].subtasks[j].materials[k].quantity === 0) {
                        var mat = $filter('filter')(sub[0].materials, {
                            '_id': $scope.my_bid.bid[i].subtasks[j].materials[k].material_id }, true);

                        if(mat.length !== 1) {
                            toaster.pop('error', 'Material Error', 'Did not get the right number of materials.  Contact Admin.');
                        } else {
                            if(sub[0].unit === mat[0].unit) {
                                if($scope.my_bid.bid[i].subtasks[j].materials[k].is_overridden) {
                                    $scope.my_bid.bid[i].subtasks[j].materials[k].quantity =
                                        $scope.my_bid.bid[i].subtasks[j].materials[k].overridden_quantity;
                                } else {
                                    $scope.my_bid.bid[i].subtasks[j].materials[k].quantity =
                                        $scope.getQuantityAllowed($scope.my_bid.bid[i].subtasks[j],
                                            $scope.my_bid.bid[i].subtasks[j].materials[k]);
                                }
                            }
                        }
                    }
                }
                for(var k=0; k<$scope.my_bid.bid[i].subtasks[j].equipment.length; k++) {
                    if($scope.my_bid.bid[i].subtasks[j].equipment[k].quantity === 0) {
                        var mat = $filter('filter')(sub[0].equipment, {
                            '_id': $scope.my_bid.bid[i].subtasks[j].equipment[k].equipment_id }, true);

                        if(mat.length !== 1) {
                            toaster.pop('error', 'Equipment Error',
                                'Did not get the right number of equipment items.  Contact Admin.');
                        } else {
                            if(sub[0].unit === mat[0].unit) {
                                if($scope.my_bid.bid[i].subtasks[j].equipment[k].is_overridden) {
                                    $scope.my_bid.bid[i].subtasks[j].equipment[k].quantity =
                                        $scope.my_bid.bid[i].subtasks[j].equipment[k].overridden_quantity;
                                } else {
                                    $scope.my_bid.bid[i].subtasks[j].equipment[k].quantity =
                                        $scope.getQuantityAllowed($scope.my_bid.bid[i].subtasks[j],
                                            $scope.my_bid.bid[i].subtasks[j].equipment[k]);
                                }
                            }
                        }
                    }
                }
            }
        }

        userService.getMainAccount($scope.user.username).then(function(main_user) {
            var saved_items = new BidMaterialsSaves({
                user: main_user._id,
                name: $scope.bid.bid_name,
                date: new Date(),
                supplier: $scope.my_bid.supplier,
                shortcuts: $scope.my_bid.shortcuts,
                costs: $scope.my_bid.costs,
                inclusions: $scope.my_bid.inclusions,
                exclusions: $scope.my_bid.exclusions,
                task_list: $filter('filter')($scope.my_bid.task_list, {trade: $scope.my_bid_trade}, true),
                projectType:$scope.bid.projectType || 'Single Family',
                geoLocation:$scope.bid.geoLocation || 'Southern California'
            });

            saved_items.$save();


            //might want to set up a notification here or send an email to builder

            $scope.my_bid.$update();
            $location.path('home');
        });
    };

    $scope.toggleCollapse = function(value) {
        _.each($scope.my_bid.task_list, function(task) {
            task.show = value;
            _.each(task.subtasks, function(sub) {
                sub.show = value;
            });
        });

        this.showAllTasks = value;
    };

    $scope.saveToDatabase = function() {
        var saved_tasks = angular.copy($scope.my_bid.task_list);

        if($scope.my_bid.sections && $scope.my_bid.sections.length != 9) {
            $scope.my_bid.sections = [{
                label: "Form Header",
                value: 0
            }, {
                label: "Contact Information",
                value: 1
            }, {
                label: "Proposal",
                value: 2
            }, {
                label: "Cost Breakdown",
                value: 3
            }, {
                label: "Terms & Conditions",
                value: 4
            }, {
                label: "Inclusions",
                value: 5
            }, {
                label: "Exclusions",
                value: 6
            }, {
                label: "Owner Acceptance",
                value: 7
            }, {
                label: "Page Break",
                value: 8
            }];
        }

        $scope.my_bid.$update(function(success) {
            toaster.pop('success', 'Database Saved', 'Trade Bid Updated');
            $scope.updateShowState(saved_tasks, success.task_list);
            $scope.show_spinner = false;
        }, function(err) {
            toaster.pop('error', 'Database Saved', err);
        });
    };

    $scope.updateTablePlan = function() {
        $scope.bid_tasks = [];

        $scope.my_bid.task_list.forEach(function(task, index){
            if( task.trade === $scope.my_bid_trade){
                $scope.my_bid.bid.forEach(function(bid, ii) {

                    if(bid.task_id === task._id) {
                        if(bid.plan_code === $scope.current_plan.item) {
                            bid.subtasks.forEach(function(subtask, si) {
                                task.subtasks.forEach(function(tsub, tsi) {
                                    if(subtask.task_id === tsub._id) {
                                        //if(!tsub.hours_allowed)
                                        //    tsub.hours_allowed = $scope.getHoursAllowedForItem(tsub);
                                        tsub.quantity = Number(subtask.quantity);
                                        tsub.bid_hours = Number(subtask.bid_hours);
                                        tsub.labor = Number(subtask.labor);
                                    }
                                });
                                if(!subtask.equipment) subtask.equipment = [];
                                subtask.equipment.forEach(function(eq, eidx) {
                                    task.subtasks[si].equipment.forEach(function(teq, teidx) {
                                        if(eq.equipment_id === teq._id && teq._id) {
                                            teq.quantity = Number(eq.quantity);
                                            if(teq.piece_per_size)
                                              eq.piece_per_size = teq.piece_per_size;
                                            if(eq.price_per_order)
                                              teq.price_per_order = Number(eq.price_per_order);
                                            if(eq.delivery_price)
                                              teq.delivery_price = Number(eq.delivery_price);
                                        }
                                    });
                                });
                                if(!subtask.materials) subtask.materials = [];
                                subtask.materials.forEach(function(mq, midx) {
                                    task.subtasks[si].materials.forEach(function(tmq, tmidx) {
                                        if(mq.material_id === tmq._id && tmq._id) {
                                            tmq.quantity = Number(mq.quantity);
                                            if(tmq.piece_per_size)
                                              mq.piece_per_size = tmq.piece_per_size;
                                            if(mq.price_per_order)
                                              tmq.price_per_order = Number(mq.price_per_order);
                                            if(mq.delivery_price)
                                              tmq.delivery_price = Number(mq.delivery_price);
                                        }
                                    });
                                });
                            });
                        } else {
                            //this bid does not match the current plan but it matches the task.
                            //we need to see if there is a plan/bid for this task.
                            //if there is we need to leave it alone, if there is not
                            //then we should clear it out.
                            var bid_found = false;
                            for(var i=0; i<$scope.my_bid.bid.length; i=i+1){
                                if($scope.my_bid.bid[i].task_id === task._id &&
                                    $scope.my_bid.bid[i].plan_code === $scope.current_plan.item)
                                  bid_found = true;
                            }

                            if(!bid_found){
                                task.subtasks.forEach(function(sub) {
                                    sub.quantity = 0;
                                    sub.bid_hours = 0;
                                    sub.labor = 0;
                                    sub.materials.forEach(function(mat){
                                        mat.quantity = 0;
                                        mat.materials_subtotal = 0;
                                        mat.materials_dev_subtotal = 0;
                                    });
                                    sub.equipment.forEach(function(eq) {
                                        eq.quantity = 0;
                                        eq.materials_subtotal = 0;
                                        eq.materials_dev_subtotal = 0;
                                    });
                                });
                            }
                        }
                    }
                });

                $scope.bid_tasks.push(task);
            }
        });

        $scope.bid_tasks = $filter('orderBy')($scope.bid_tasks, '_id');

        // this does not work yet.  it is stomping on the other
        // plans values and only picks up the last. Need to revisit.
        // tradeService.updateTablePlan(
        //                 $scope.my_bid.task_list,
        //                 $scope.bid_tasks,
        //                 $scope.my_bid.bid,
        //                 $scope.my_bid_trade,
        //                 $scope.current_plan.item);

        $scope.applayCalculations($scope.bid_tasks);
    };

    $scope.buildListsForPrinting = function() {
        _.each($scope.cost_breakdowns, function(cost) {
            cost.bid_tasks = [];

            var task_list = angular.copy($scope.my_bid.task_list);

            task_list.forEach(function(task, index){
                if( task.trade === $scope.my_bid_trade){
                    $scope.my_bid.bid.forEach(function(bid, ii) {

                        if(bid.task_id === task._id) {
                            if(bid.plan_code === cost.item) {
                                bid.subtasks.forEach(function(subtask, si) {
                                    task.subtasks.forEach(function(tsub, tsi) {
                                        if(subtask.task_id === tsub._id) {
                                            //if(!tsub.hours_allowed)
                                            //    tsub.hours_allowed = $scope.getHoursAllowedForItem(tsub);
                                            tsub.quantity = Number(subtask.quantity);
                                            tsub.bid_hours = Number(subtask.bid_hours);
                                            tsub.labor = Number(subtask.labor);
                                        }
                                    });
                                    if(!subtask.equipment) subtask.equipment = [];
                                    subtask.equipment.forEach(function(eq, eidx) {
                                        task.subtasks[si].equipment.forEach(function(teq, teidx) {
                                            if(eq.equipment_id === teq._id && teq._id) {
                                                teq.quantity = Number(eq.quantity);
                                                if(teq.piece_per_size)
                                                  eq.piece_per_size = teq.piece_per_size;
                                                if(eq.price_per_order)
                                                  teq.price_per_order = Number(eq.price_per_order);
                                                if(eq.delivery_price)
                                                  teq.delivery_price = Number(eq.delivery_price);
                                            }
                                        });
                                    });
                                    if(!subtask.materials) subtask.materials = [];
                                    subtask.materials.forEach(function(mq, midx) {
                                        task.subtasks[si].materials.forEach(function(tmq, tmidx) {
                                            if(mq.material_id === tmq._id && tmq._id) {
                                                tmq.quantity = Number(mq.quantity);
                                                if(tmq.piece_per_size)
                                                  mq.piece_per_size = tmq.piece_per_size;
                                                if(mq.price_per_order)
                                                  tmq.price_per_order = Number(mq.price_per_order);
                                                if(mq.delivery_price)
                                                  tmq.delivery_price = Number(mq.delivery_price);
                                            }
                                        });
                                    });
                                });
                            } else {
                                //this bid does not match the current plan but it matches the task.
                                //we need to see if there is a plan/bid for this task.
                                //if there is we need to leave it alone, if there is not
                                //then we should clear it out.
                                var bid_found = false;
                                for(var i=0; i<$scope.my_bid.bid.length; i=i+1){
                                    if($scope.my_bid.bid[i].task_id === task._id &&
                                        $scope.my_bid.bid[i].plan_code === cost.item)
                                      bid_found = true;
                                }

                                if(!bid_found){
                                    task.subtasks.forEach(function(sub) {
                                        sub.quantity = 0;
                                        sub.bid_hours = 0;
                                        sub.labor = 0;
                                        sub.materials.forEach(function(mat){
                                            mat.quantity = 0;
                                            mat.materials_subtotal = 0;
                                            mat.materials_dev_subtotal = 0;
                                        });
                                        sub.equipment.forEach(function(eq) {
                                            eq.quantity = 0;
                                            eq.materials_subtotal = 0;
                                            eq.materials_dev_subtotal = 0;
                                        });
                                    });
                                }
                            }
                        }
                    });

                    cost.bid_tasks.push(task);
                }
            });

            cost.bid_tasks = $filter('orderBy')(cost.bid_tasks, '_id');

            $scope.applayCalculations(cost.bid_tasks);
        })
    };

    $scope.deleteMaterial = function(task_id, material, index){
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        //first see if there is a bid associated with
        //this material and remove it
        var bid_task = $filter('filter')($scope.my_bid.bid, {'task_id': task_id}, true);
        if(bid_task.length) {
            for(var i=0; i<bid_task.length; i++) {
                for(var j=0; j<bid_task[i].subtasks.length; j++) {
                    var inlist = $filter('filter')(bid_task[i].subtasks[j].materials, {
                        'material_id': material._id}, true);

                    if(inlist.length) {
                        var idx = bid_task[i].subtasks[j].materials.indexOf(inlist);
                        bid_task[i].subtasks[j].materials.splice(idx, 1);
                    }
                }
            }
        }

        //remove material from the trade's task list
        var task_list = $filter('filter')($scope.my_bid.task_list, { _id: task_id}, true);

        if(task_list.length !== 1) {
            alert('There is a problem with the task_list size in deleteMaterial.  Call Admin.');
            return;
        }

        var idx = task_list[0].subtasks[index].materials.indexOf(material);
        task_list[0].subtasks[index].materials.splice(idx, 1);

        var saved_tasks = angular.copy($scope.my_bid.task_list);

        $scope.show_spinner = true;
        $scope.my_bid.$update(function(success) {
            toaster.pop('success', 'Material Removed', 'Database Updated');
            $scope.updateShowState(saved_tasks, success.task_list);
            $scope.my_bid = success;
            $scope.show_spinner = false;
        }, function(error) {
            toaster.pop('error', 'Material Remove Error', error);
        });
    };

    $scope.updateShowState = function(old_tasks, new_tasks) {
        var new_tasks = $filter('filter')(new_tasks, {'trade': $scope.my_bid_trade}, true);
        var old_tasks = $filter('filter')(old_tasks, {'trade': $scope.my_bid_trade}, true);

        _.each(new_tasks, function(nTask) {
            var oTask = $filter('filter')(old_tasks, {'_id':nTask._id}, true)[0];
            if(!oTask) {
                toaster.pop('error', 'Task Error', 'Contact Admin');
            } else {
                nTask.show = oTask.show;
                _.each(nTask.subtasks, function(nSub) {
                    var oSub = $filter('filter')(oTask.subtasks, {'_id': nSub._id}, true)[0];
                    if(!oSub) {
                        toaster.pop('error', 'Subtask Error', 'Contact Admin');
                    } else {
                        nSub.show = oSub.show;
                    }
                });
            }
        });
    };

    $scope.addMultipleMaterials = function(
        override_task_id, override_subtask_idx, new_materials, new_note) {
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        if(new_materials.length === 0) {
            alert('No Material Selected!');
            return;
        }

        var time = new Date().getTime();
        var times = [];

        _.each(new_materials, function(mat, idx) {
            times.push(time + idx);
        });

        _.each(new_materials, function(material, index) {
            material.note = new_note;
            $scope.addMaterialForMultiple(override_task_id, override_subtask_idx, material, times[index]);
        });

        var saved_tasks = angular.copy($scope.my_bid.task_list);

        $scope.show_spinner = true;
        $scope.my_bid.$update(function(success) {
            toaster.pop('success', 'Material Added', 'Database Updated');
            $scope.updateShowState(saved_tasks, success.task_list);
            $scope.my_bid = success;
            $scope.show_spinner = false;
        }, function(error) {
            toaster.pop('error', 'Material Add Multiple Error', error);
        });

        this.current_material = this.current_category = '';
        if(this.current_material)
          this.current_material.note = '';

        this.new_supplier = this.new_category = '';
        this.new_materials = [];
    };

    $scope.addMaterialForMultiple = function(task_id, idx, material, time) {
        _.each($scope.my_bid.task_list, function(bid, index) {
            if(bid._id === task_id){
                var new_mat = ({
                    _id: time+index,
                    //material_id: material._id,
                    name: material.name,
                    supplier: material.supplier,
                    description: material.description,
                    unit: material.unit.unit,
                    trade: material.trade,
                    note: material.note,
                    units_per_order: Number(material.units_per_order),
                    price_per_order: material.price_per_order,
                    piece_per_size: material.piece_per_size,
                    delivery_price: material.delivery_price,
                    delivery_offset: material.delivery_offset,
                    isInventory: material.isInventory || false
                });

                bid.subtasks[idx].materials.push(new_mat);
            }
        });
    };

    $scope.addMaterial = function(task_id, idx, material) {
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        if(!material) {
            alert('No Material Selected!');
            return;
        }

        var bid_task = $filter('filter')($scope.my_bid.task_list, {'_id': task_id}, true)[0];

        if(!bid_task) {
            toaster.pop('error', 'Bid Task Error', 'Could not get the associated bid task. Contact admin.');
            return;
        }

        var time = new Date().getTime();

        var new_mat = ({
            _id: time,
            name: material.name,
            //material_id: material._id,
            supplier: material.supplier,
            description: material.description,
            unit: material.unit.unit,
            trade: material.trade,
            note: material.note,
            units_per_order: Number(material.units_per_order),
            price_per_order: material.price_per_order,
            piece_per_size: material.piece_per_size,
            delivery_price: material.delivery_price,
            delivery_offset: material.delivery_offset,
            isInventory:material.isInventory || false
        });

        bid_task.subtasks[idx].materials.push(new_mat);

        var saved_tasks = angular.copy($scope.my_bid.task_list);

        //$scope.show_spinner = true;
        $scope.submitting = true;
        $loading.start('add-material');
        $scope.my_bid.$update(function(success) {
            toaster.pop('success', 'Material Added', 'Database Updated');
            $scope.updateShowState(saved_tasks, success.task_list);
            $scope.my_bid = success;
            $scope.submitting = false;
            $loading.finish('add-material');
            //$scope.show_spinner = false;
        }, function(error) {
            toaster.pop('error', 'Material Add Error', error);
        });

        this.current_material = this.current_category = '';
        if(this.current_material)
          this.current_material.note = '';

        this.new_supplier = this.new_category = this.new_material = '';
    };

    $scope.deleteEquipment = function(task_id, equipment, index){
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        //first see if there is a bid associated with
        //this equipment and remove it
        var bid_task = $filter('filter')($scope.my_bid.bid, {'task_id': task_id}, true);
        if(bid_task.length) {
            for(var i=0; i<bid_task.length; i++) {
                for(var j=0; j<bid_task[i].subtasks.length; j++) {
                    var inlist = $filter('filter')(bid_task[i].subtasks[j].equipment, {
                        'equipment_id': equipment._id}, true);

                    if(inlist.length) {
                        var idx = bid_task[i].subtasks[j].equipment.indexOf(inlist);
                        bid_task[i].subtasks[j].equipment.splice(idx, 1);
                    }
                }
            }
        }

        //remove equipment from the global task list
        var task_list = $filter('filter')($scope.my_bid.task_list, { _id: task_id}, true);

        if(task_list.length !== 1) {
            alert('There is a problem with the task_list size in deleteEquipment.  Call Admin.');
            return;
        }

        var idx = task_list[0].subtasks[index].equipment.indexOf(equipment);
        task_list[0].subtasks[index].equipment.splice(idx, 1);

        var saved_tasks = angular.copy($scope.my_bid.task_list);

        $scope.show_spinner = true;
        $scope.my_bid.$update(function(success) {
            toaster.pop('success', 'Equipment Removed', 'Database Updated');
            $scope.updateShowState(saved_tasks, success.task_list);
            $scope.my_bid = success;
            $scope.show_spinner = false;
        }, function(error) {
            toaster.pop('error', 'Equipment Remove Error', error);
        });
    };

    $scope.addMultipleEquipment = function(
        override_task_id, override_subtask_idx, new_equipments, new_note) {
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        if(new_equipments.length === 0) {
            alert('No Equipment Selected!');
            return;
        }

        var time = new Date().getTime();
        var times = [];

        _.each(new_equipments, function(mat, idx) {
            times.push(time + idx);
        });

        _.each(new_equipments, function(equip, index) {
            equip.note = new_note;
            $scope.addEquipmentForMultiple(override_task_id, override_subtask_idx, equip, times[index]);
        });

        var saved_tasks = angular.copy($scope.my_bid.task_list);

        $scope.show_spinner = true;
        $scope.my_bid.$update(function(success) {
            toaster.pop('success', 'Equipment Added', 'Database Updated');
            $scope.updateShowState(saved_tasks, success.task_list);
            $scope.my_bid = success;
            $scope.show_spinner = false;
        }, function(error) {
            toaster.pop('error', 'Equipment Add Error', error);
        });

        this.current_equipment = this.current_category = '';
        if(this.current_equipment)
          this.current_equipment.note = '';

        this.new_supplier = this.new_category = '';
        this.new_equipments = [];
    };

    $scope.addEquipmentForMultiple = function(task_id, idx, equipment, time) {
        _.each($scope.my_bid.task_list, function(bid, index) {
            if(bid._id === task_id){
                var new_mat = ({
                    _id: time,
                    name: equipment.name,
                    //equipment_id: equipment._id,
                    supplier: equipment.supplier,
                    description: equipment.description,
                    unit: equipment.unit.unit,
                    trade: equipment.trade,
                    note: equipment.note,
                    units_per_order: Number(equipment.units_per_order),
                    price_per_order: equipment.price_per_order,
                    piece_per_size: equipment.piece_per_size,
                    delivery_price: equipment.delivery_price,
                    delivery_offset: equipment.delivery_offset
                });

                bid.subtasks[idx].equipment.push(new_mat);
            }
        });
    };

    $scope.addEquipment = function(task_id, idx, equipment) {
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        if(!equipment) {
            toaster.pop('error', 'No Equipment Selected!');
            return;
        }

        var bid_task = $filter('filter')($scope.my_bid.task_list, {'_id': task_id}, true)[0];

        if(!bid_task) {
            toaster.pop('error', 'Bid Task Error', 'Could not get the associated bid task. Contact admin.');
            return;
        }

        var time = new Date().getTime();

        var new_mat = ({
            _id: time,
            name: equipment.name,
            //equipment_id: equipment._id,
            supplier: equipment.supplier,
            description: equipment.description,
            unit: equipment.unit.unit,
            trade: equipment.trade,
            note: equipment.note,
            units_per_order: Number(equipment.units_per_order),
            price_per_order: equipment.price_per_order,
            piece_per_size: equipment.piece_per_size,
            delivery_price: equipment.delivery_price,
            delivery_offset: equipment.delivery_offset
        });

        bid_task.subtasks[idx].equipment.push(new_mat);

        var saved_tasks = angular.copy($scope.my_bid.task_list);

        $scope.submitting = true;
        $loading.start('add-equipment');
        $scope.my_bid.$update(function(success) {
            toaster.pop('success', 'Equipment Added', 'Database Updated');
            $scope.updateShowState(saved_tasks, success.task_list);
            $scope.my_bid = success;
            $scope.submitting = false;
            $loading.finish('add-equipment');
        }, function(error) {
            toaster.pop('error', 'Equipment Add Error', error);
        });

        this.current_equipment = this.current_category = '';
        if(this.current_equipment)
          this.current_equipment.note = '';

        this.new_supplier = this.new_category = this.new_equipment = '';
    };

    $scope.applayCalculations = function(tasks) {
        taskTotalsService.getCalculations(tasks, $scope.company_factors);
console.log('calculated');
        $scope.bid_total = tasks.bid_total;
        $scope.bid_general_liability = tasks.bid_general_liability;
        $scope.bid_total_labor = tasks.bid_total_labor;
        $scope.bid_total_materials = tasks.bid_total_materials;
        $scope.bid_materials_taxes = tasks.bid_materials_taxes;
        $scope.bid_materials_subtotal = tasks.bid_materials_subtotal;
        $scope.bid_total_equipment = tasks.bid_total_equipment;
        $scope.bid_equipment_subtotal = tasks.bid_equipment_subtotal;
        $scope.bid_equipment_taxes = tasks.bid_equipment_taxes;
        $scope.bid_direct_labor = tasks.bid_direct_labor;
        $scope.bid_mark_up = tasks.bid_mark_up;
        $scope.bid_workers_comp = tasks.bid_workers_comp;
        $scope.bid_payroll_taxes = tasks.bid_payroll_taxes;

        var inlist = $filter('filter')($scope.my_bid.overrides,
            {'plan_code': $scope.current_plan.item}, true);

        if(inlist.length === 0) {
          $scope.bid_mark_up = tasks.bid_mark_up;
          $scope.bid_overhead_and_profit = tasks.bid_overhead_and_profit;
        } else if(inlist.length === 1) {
            //so...we have an override here and need to adjust
            //the tasks that make up this plan to remove the amounts
            //until it is made up for
            var total_adjust = inlist[0].original_amount - inlist[0].amount;
            for(var i=0; i<tasks.length; i++) {
                if(tasks[i].bid_mark_up <= total_adjust) {
                    total_adjust -= tasks[i].bid_mark_up;
                    tasks[i].bid_mark_up = 0;
                } else {
                    tasks[i].bid_mark_up -= total_adjust;
                    total_adjust = 0;
                    break;
                }
            }

            $scope.bid_mark_up = inlist[0].amount;
            $scope.bid_overhead_and_profit = inlist[0].amount;
            $scope.bid_total -= inlist[0].original_amount - inlist[0].amount;
        }

        inlist = $filter('filter')($scope.my_bid.extra_liability,
            {'plan_code': $scope.current_plan.item}, true);

        if(inlist.length === 1) {
            $scope.bid_general_liability += inlist[0].amount;
            //$scope.bid_total += inlist[0].amount;
            $scope.bid_total = $scope.bid_total_labor + $scope.bid_total_materials +
                $scope.bid_total_equipment + $scope.bid_general_liability + $scope.bid_mark_up;
        }

        $scope.bid_total_hours_allowed = tasks.bid_total_hours_allowed;
        $scope.bid_direct_labor = tasks.bid_direct_labor;
        $scope.bid_workers_comp = tasks.bid_workers_comp;
        $scope.bid_payroll_taxes = tasks.bid_payroll_taxes;

        $scope.bid_menu.forEach(function(bid) {
            if($scope.current_plan.item === bid.item) {
                if(bid.item !== 'Cover') {
                    bid.bid_total = tasks.bid_total;
                    bid.bid_direct_labor = tasks.bid_direct_labor;
                    bid.bid_total_labor = tasks.bid_total_labor;
                    bid.bid_total_materials = tasks.bid_total_materials;
                    bid.bid_total_equipment = tasks.bid_total_equipment;
                    bid.bid_general_liability = tasks.bid_general_liability;
                    bid.bid_workers_comp = tasks.bid_workers_comp;
                    bid.bid_payroll_taxes = tasks.bid_payroll_taxes;
                    bid.bid_overhead_and_profit = tasks.bid_overhead_and_profit;
                    bid.bid_total_hours_allowed = tasks.bid_total_hours_allowed;

                    var inlist = $filter('filter')($scope.my_bid.overrides,
                        {'plan_code': $scope.current_plan.item}, true);

                    if(inlist.length === 0) {
                      bid.bid_mark_up = tasks.bid_mark_up;
                      bid.bid_overhead_and_profit = tasks.bid_overhead_and_profit;
                    } else if(inlist.length === 1) {
                        bid.bid_mark_up = inlist[0].amount;
                        bid.bid_overhead_and_profit = inlist[0].amount;
                        bid.bid_total -= inlist[0].original_amount - inlist[0].amount;
                    }

                    inlist = $filter('filter')($scope.my_bid.extra_liability,
                        {'plan_code': $scope.current_plan.item}, true);

                    if(inlist.length === 1) {
                        bid.bid_general_liability += inlist[0].amount;
                        bid.bid_total = bid.bid_total_labor + bid.bid_total_materials +
                            bid.bid_total_equipment + bid.bid_general_liability +
                            bid.bid_mark_up;
                    }
                }
            }
        });
    };

    $scope.buildBidCoverPage = function() {
        $scope.bid_menu.forEach(function(bid) {
            if(bid.item === 'Trade Rates') return;
            if(bid.item === 'Total Materials') return;
            if(bid.item === 'Materials') return;
            if(bid.item === 'Equipment') return;
            if(bid.item === 'Shortcuts') return;
            if(bid.item === 'Labor') return;
            if(bid.item !== 'Proposal') {
                $scope.current_plan = bid;
                $scope.updateTablePlan();
            }
        });
    };

    $scope.filterItems = ['Labor', 'Materials', 'Equipment', 'Shortcuts', 'Proposal', 'Trade Rates', 'Total Materials'];

    $scope.filterMenuItems = function(val) {
        return ($scope.filterItems.indexOf(val.item) === -1);
    };

    $scope.onSelect = function(item) {
        $scope.current_plan = item;
        if($scope.current_plan.item === 'Cover') {
            data = [];
            $scope.buildBidCoverPage();
        } else if($scope.current_plan.item === 'Labor') {
            data = [];
        } else if($scope.current_plan.item === 'Materials') {
            data = [];
        } else if($scope.current_plan.item === 'Equipment') {
            data = [];
        } else if($scope.current_plan.item === 'Trade Rates') {
            data = [];
        } else if($scope.current_plan.item === 'Total Materials') {
            data = [];
            $scope.materials =
                bidRequestEditService.getMaterials($scope.my_bid.bid, $scope.my_bid.task_list);
        } else if($scope.current_plan.item === 'Shortcuts') {
            data = [];
        } else if($scope.current_plan.item === 'Proposal') {
            data = [];
            if(!$scope.cost_breakdowns || $scope.cost_breakdowns.length == 0) {
                $scope.cost_breakdowns = [];
                $scope.bid.bid_total = 0;
                _.each($scope.bid_menu, function(bid) {
                    if($scope.filterMenuItems(bid)) {
                        $scope.current_plan = bid;
                        $scope.updateTablePlan();
                        bid.quantity = $scope.getPlanQuantity(bid.item);
                        bid.total = bid.bid_total * bid.quantity;
                        $scope.cost_breakdowns.push(bid);
                        $scope.bid.bid_total += bid.total;
                    }
                });
            }

            $scope.current_plan = $filter('filter')($scope.bid_menu, {'item': 'Proposal'}, true)[0];

            $scope.buildListsForPrinting();

            if(!$scope.my_bid.signed_by && $scope.bid.purchasing_agent_info) {
                $scope.my_bid.signed_by = $scope.bid.purchasing_agent_info.name;
            }
        } else {
            $scope.current_plan_notes = $filter('filter')($scope.my_bid.plans, {
                'code': $scope.current_plan.item}, true);
            if(!$scope.current_plan_notes || $scope.current_plan_notes.length == 0) {
                $scope.current_plan_notes = {
                    code: $scope.current_plan.item,
                    notes: ''
                }
            } else {
                $scope.current_plan_notes = $scope.current_plan_notes[0];
            }
            $scope.updateTablePlan();
        }
    };

    $scope.updatePlanQuantity = function(index) {
        var plan = $filter('filter')($scope.bid.plan_codes, {'code': $scope.cost_breakdowns[index].item}, true);
        if(plan.length == 1) {
            plan[0].quantity = $scope.cost_breakdowns[index].quantity;
            $scope.show_spinner = true;
            $scope.bid.$update(function(success) {
                $scope.bid = success;
                $scope.bid.project_start_date = new Date($scope.bid.project_start_date);
                $scope.cost_breakdowns = [];
                $scope.bid.bid_total = 0;
                _.each($scope.bid_menu, function(bid) {
                    if($scope.filterMenuItems(bid)) {
                        $scope.current_plan = bid;
                        $scope.updateTablePlan();
                        bid.quantity = $scope.getPlanQuantity(bid.item);
                        bid.total = bid.bid_total * bid.quantity;
                        $scope.cost_breakdowns.push(bid);
                        $scope.bid.bid_total += bid.total;
                    }
                });
                $scope.current_plan = $filter('filter')($scope.bid_menu, {'item': 'Proposal'}, true)[0];
                toaster.pop('success', 'Bid Updated');
                $scope.show_spinner = false;
            }, function(error) {
                toaster.pop('error', 'Bid Update Error', error);
            })
        }
    };

    $scope.updatePlanNotes = function() {
        if($scope.my_bid.plans) {
            var plan = $filter('filter')($scope.my_bid.plans, {
                'code': $scope.current_plan.item }, true);

            if(plan && plan.length == 1) {
                plan[0].notes = this.current_plan_notes.notes;
            } else if(plan && plan.length == 0) {
                $scope.my_bid.plans.push({
                    code: $scope.current_plan.item,
                    notes: this.current_plan_notes.notes
                });
            }
        } else {
            $scope.my_bid.plans.push({
                code: $scope.current_plan.item,
                notes: this.current_plan_notes.notes
            });
        }

        //var saved_tasks = angular.copy($scope.my_bid.task_list);

        $scope.show_spinner = true;
        $scope.my_bid.$update(function(success) {
            toaster.pop('success', 'Notes Saved', 'Database Updated');
            //$scope.updateShowState(saved_tasks, success.task_list);
            $scope.my_bid = success;
            $scope.show_spinner = false;
        }, function(error) {
            toaster.pop('error', 'Note Save Error', error);
        });
    }

    $scope.setTaskEditId =  function(pid) {
        $scope.taskEditId = pid;
    };

    $scope.setMaterialEdit =  function(item) {
        $scope.materialEditId = item._id;
        var unit = $filter('filter')($scope.units, {'unit': item.unit}, true);
        item.unit = unit[0];
    };

    $scope.setEquipmentEdit =  function(item) {
        $scope.equipmentEditId = item._id;
        var unit = $filter('filter')($scope.units, {'unit': item.unit}, true);
        item.unit = unit[0];
    };

    $scope.next =  function(item) {
        //pid -1 is the index of the current task so lets just start with the next task and iterate
        $scope.update(item);
        var current_task_idx = item._id;
        for(; current_task_idx < $scope.my_bid.task_list.length; current_task_idx = current_task_idx + 1) {
            if($scope.my_bid.task_list[current_task_idx].trade === $scope.my_bid_trade) {
                $scope.taskEditId = $scope.my_bid.task_list[current_task_idx]._id;
                break;
            }
        }
    };

    $scope.updateMaterial = function(bid, material) {
        //get the unit string for saving
        material.unit = (material.unit)?material.unit.unit:'';

        var saved_tasks = angular.copy($scope.my_bid.task_list);

        $scope.show_spinner = true;
        $scope.my_bid.$update(function(success) {
            toaster.pop('success', 'Material Saved', 'Database Updated');
            $scope.updateShowState(saved_tasks, success.task_list);
            $scope.my_bid = success;
            $scope.materialEditId = -1;
            $scope.show_spinner = false;
        }, function(error) {
            toaster.pop('error', 'Material Save Error', error);
        });
    };

    $scope.updateEquipment = function(bid, equipment) {
        //get the unit string for saving
        equipment.unit = (equipment.unit)?equipment.unit.unit:'';

        var saved_tasks = angular.copy($scope.my_bid.task_list);

        $scope.show_spinner = true;
        $scope.my_bid.$update(function(success) {
            toaster.pop('success', 'Equipment Saved', 'Database Updated');
            $scope.updateShowState(saved_tasks, success.task_list);
            $scope.my_bid = success;
            $scope.equipmentEditId = -1;
            $scope.show_spinner = false;
        }, function(error) {
            toaster.pop('error', 'Equipment Save Error', error);
        });
    };

    $scope.update = function(item) {
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        $scope.show_spinner = true;
        //for some reason the view is not passing the currently
        //calculated value so...i'm going to do it here.  sucks
        for(var i=0; i<item.subtasks.length; i++) {
            for(var j=0; j<item.subtasks[i].materials.length; j++) {
                var mat = item.subtasks[i].materials[j];
                if(item.unit === item.subtasks[i].unit)
                  mat.quantity_allowed = $scope.getQuantityAllowed(item.subtasks[i], mat);

                var inlist = $filter('filter')($scope.materials, {
                    'task': item.task,
                    'name': mat.name,
                    'note': mat.note,
                    'price_per_order': mat.price_per_order }, true);

                if(inlist.length === 0) {
                    mat.task = item.task;
                    $scope.materials.push(angular.copy(mat));
                    $scope.materials.task_id = item.task_id;
                    $scope.materials.subtask_id = item.subtasks[i].task_id;
                } else {
                    inlist[0].quantity = mat.quantity ? mat.quantity : mat.quantity_allowed;
                }
            }
        }

        if(bidTotalsService.updateBid(item, $scope.current_plan.item, $scope.my_bid.bid)) {
            $scope.my_bid.$update();
            $scope.updateTablePlan();
            $scope.show_spinner = false;
        } else {
            toaster.pop('error', 'Bid Update', 'There was a problem updating the bid.');
        }
    };

    $scope.copyPlanData = function(from_plan, to_plan) {
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        $scope.show_spinner = true;
        if(!from_plan || from_plan.item === 'Labor') {
            alert('No From Plan Selected for Copying');
            return;
        }
        if(!to_plan || to_plan.item === 'Labor') {
            alert('No To Plan Selected for Copying');
            return;
        }
        if(!from_plan || from_plan.item === 'Materials') {
            alert('No From Plan Selected for Copying');
            return;
        }
        if(!to_plan || to_plan.item === 'Materials') {
            alert('No To Plan Selected for Copying');
            return;
        }
        if(!from_plan || from_plan.item === 'Equipment') {
            alert('No From Plan Selected for Copying');
            return;
        }
        if(!to_plan || to_plan.item === 'Equipment') {
            alert('No To Plan Selected for Copying');
            return;
        }
        to_plan.bid_direct_labor = from_plan.bid_direct_labor;
        to_plan.bid_general_liability = from_plan.bid_general_liability;
        to_plan.bid_overhead_and_profit = from_plan.bid_overhead_and_profit;
        to_plan.bid_payroll_taxes = from_plan.bid_payroll_taxes;
        to_plan.bid_total = from_plan.bid_total;
        to_plan.bid_total_equipment = from_plan.bid_total_equipment;
        to_plan.bid_total_hours_allowed = from_plan.bid_total_hours_allowed;
        to_plan.bid_total_labor = from_plan.bid_total_labor;
        to_plan.bid_total_materials = from_plan.bid_total_materials;
        to_plan.bid_workers_comp = from_plan.bid_workers_comp;

        for(var i=$scope.my_bid.bid.length-1; i>=0; i--) {
            if($scope.my_bid.bid[i].plan_code === to_plan.item)
                $scope.my_bid.bid.splice(i, 1);
        }

        var trade_bid = $filter('filter')($scope.my_bid.bid, {plan_code: from_plan.item}, true);

        for(var i=0; i<trade_bid.length; i++) {
            var temp = {};
            angular.copy(trade_bid[i], temp);
            delete temp._id;
            temp.plan_code = to_plan.item;
            $scope.my_bid.bid.push(temp);
        }

        $scope.my_bid.$update();

        $scope.updateTablePlan();
        $scope.show_spinner = false;
    };

    $scope.setEditId = function(pid, idx) {
        $scope.editId = pid._id;
        $scope.editSub = idx._id;
        if(pid !== -1)
          $scope.item = idx;
    };

    $scope.closeEdit = function(item) {
        $scope.updateSubtask(item);
        $scope.editId = -1;
        $scope.editSub = -1;
    };

    $scope.getHoursAllowed = function() {
        return bidTotalsService.getHoursAllowedForItem(this.item);
    };

    $scope.getHoursAllowedForItem = function(item) {
        return bidTotalsService.getHoursAllowedForItem(item);
    };

    $scope.getCurrentNetPay = function() {
        return bidTotalsService.getCurrentNetPay(this.item);
        // return taskTotalsService.getCurrentNetPay(this.item.hours_allowed,
        //     this.item.crew_rate, this.item.quantity, this.item.piece_rate);
    }

    $scope.getQuantityAllowed = function(subtask, material) {
        return bidTotalsService.getQuantityAllowed(subtask, material);
        // if(subtask.unit === material.unit)
        //   return material.quantity ? material.quantity : subtask.quantity / material.piece_per_size;
        // else
        //   return material.quantity;
    }

    $scope.getPlanQuantity = function(plan) {
        return $filter('filter')($scope.bid.plan_codes, {'code': plan}, true)[0].quantity;
    }

    $scope.updateSubtask = function(item) {
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        if(!item.piece_per_hour_rate) item.piece_per_hour_rate = 0;
        if(!item.piece_rate) item.piece_rate = 0;

        var task = $filter('filter')($scope.my_bid.task_list, {
            'trade': item.trade, 'task': item.task}, true);

        if(task.length !== 1) {
            toaster.pop('error', 'Getting Task', 'Issue getting task for updating');
            return;
        }

        var sub = $filter('filter')(task[0].subtasks, {
            '_id': item._id, 'name': item.name}, true);

        if(sub.length !== 1) {
            toaster.pop('error', 'Getting Task', 'Issue getting subtask for updating');
            return;
        }
        sub[0].crew_rate = Number(item.crew_rate);
        sub[0].piece_per_hour_rate = Number(item.piece_per_hour_rate);
        sub[0].piece_rate = Number(item.piece_rate);
        sub[0].piece_per_size = Number(item.piece_per_size);
        sub[0].unit = item.unit;

        var saved_tasks = angular.copy($scope.my_bid.task_list);

        $scope.show_spinner = true;
        $scope.my_bid.$update(function(res) {
            toaster.pop('success', 'Bid Database', 'Subtask Updated.');
            $scope.updateShowState(saved_tasks, res.task_list);
            $scope.show_spinner = false;
        }, function(error) {
            toaster.pop('error', 'Bid Database', 'Problem saving the subtask data.');
        });
    };

    $scope.getMaterialTotal = function(item, mat) {
        return bidTotalsService.getMaterialTotal(item, mat);
    };

    $scope.getMaterialSubTotal = function(item, mat) {
        var costs = ($scope.my_bid.costs)?$scope.my_bid.costs:$scope.company_factors;
        return bidTotalsService.getMaterialSubTotal(
            item, mat, costs.sales_tax);
    };

    $scope.getEquipmentSubTotal = function(item, mat) {
        var costs = ($scope.my_bid.costs)?$scope.my_bid.costs:$scope.company_factors;
        return bidTotalsService.getMaterialSubTotal(
            item, mat, costs.equipment_tax);
    };

    $scope.getDevSubtotal = function(item, mat) {
        return bidTotalsService.getDevSubtotal(item, mat);
    };

    $scope.updateRates = function() {
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        $scope.my_bid.costs = this.company_factors;
        $scope.show_spinner = true;
        $scope.my_bid.$update(function(res) {
            toaster.pop('success', 'Database', 'Trade rates saved');
            $scope.company_factors = res.costs;
            $scope.show_spinner = false;
        }, function(error) {
            toaster.pop('error', 'Database', 'Problem saving the trade rate information');
        });
    };

    $scope.getTradeString = function(trade) {
        return tradeCodeService.getName(trade);
    };

    $scope.getTradeCode = function(trade) {
        return tradeCodeService.getCode(trade);
    };

    $scope.updateSubtaskValues = function() {
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        // Was not having fun with nested promises and went the old
        // fasioned for loop since the data sets I was working with
        // didn't take that long.  This might be an issue with larger
        // data so I left what I had in case we need to revisit.

        // var promise_main = [];
        // //first get just my trade tasks from the task list
        // var bid_list = $filter('filter')($scope.my_bid.task_list, {'trade': $scope.trade_code}, true);

        // //now loop through the tasks that i have set up
        // $scope.my_trade.subtasks.forEach(function(subtask) {
        //     var promise_sub = [];
        //     var defer1 = $q.defer();
        //     //subtask.subtask_id.subtask_code and subtask.subtask_id.subtask_name
        //     var tasks = $filter('filter')(bid_list, {'task': subtask.task}, true);
        //     tasks.forEach(function(task) {
        //         var defer2 = $q.defer();
        //         var inlist = $filter('filter')(task.subtasks, {'name': subtask.subtask_id.subtask_name}, true);

        //         inlist[0].crew_rate = subtask.crew_rate;
        //         inlist[0].piece_per_hour_rate = subtask.piece_per_hour_rate;
        //         inlist[0].piece_rate = subtask.piece_rate;
        //         defer2.resolve(inlist[0]);
        //         promise_sub.push(defer2.promise);
        //     });
        //     defer1.resolve(tasks);
        //     promise_main.push(defer1.promise);

        // });

        // $q.all(promise_main).then(function(results) {
        //     console.log(results);
        //     $scope.my_bid.task_list;
        //     //$scope.my_bid.$update();
        // });

        var bid_list = $filter('filter')($scope.my_bid.task_list, {'trade': $scope.trade_code}, true);

        for(var i=0; i<$scope.my_trade.subtasks.length; i++) {
            var tasks = $filter('filter')(bid_list, {'task': $scope.my_trade.subtasks[i].task}, true);

            for(var j=0; j<tasks.length; j++) {
                var inlist = $filter('filter')(tasks[j].subtasks, {'name': $scope.my_trade.subtasks[i].name}, true);

                if(inlist.length === 1) {
                    //var unit = $filter('filter')($scope.units, {'unit': inlist[0].unit}, true);
                    //inlist[0].unit = unit[0];
                    inlist[0].unit = $scope.my_trade.subtasks[i].unit;
                    inlist[0].crew_rate = $scope.my_trade.subtasks[i].crew_rate;
                    inlist[0].piece_per_hour_rate = $scope.my_trade.subtasks[i].piece_per_hour_rate;
                    inlist[0].piece_rate = $scope.my_trade.subtasks[i].piece_rate;
                }
            }
        }

        $scope.my_bid.$update();
    };

    $scope.editCrewRate = function (item) {
        item.crewRateEditing = true;
    };

    $scope.doneCrewRateEditing = function (item) {
        if(!item.crewRateEditing) return;

        $scope.updateSubtask(item);

        item.crewRateEditing = false;
    };

    $scope.editLaborBidNote = function (item) {
        item.laborBidNoteEditing = true;
    };

    $scope.doneLaborBidNoteEditing = function (item) {
        if(!item.laborBidNoteEditing) return;


        //var bidUpdate = $filter('filter')($scope.my_bid.bid,

        $scope.updateSubtask(item);

        item.laborBidNoteEditing = false;
    };

    $scope.editOverride = function (item) {
        var inlist = $filter('filter')($scope.my_bid.overrides, {
            'plan_code': item.item}, true);

        if(inlist.length === 0) {
            //we don't have an entry for this so set it up
            //we will save and do logic later.  we have to
            //do this here so we have the original_amount
            //prior to any user edits
            $scope.my_bid.overrides.push({
                'plan_code': item.item,
                'enabled': false,
                'current_amount': item.bid_overhead_and_profit,
                'original_amount': item.bid_overhead_and_profit,
                'amount': item.bid_overhead_and_profit
            });
        } else if(inlist.length === 1) {
            inlist[0].current_amount = item.bid_overhead_and_profit;
        }

        item.overrideEditing = true;
    };

    $scope.doneOverrideEditing = function (item) {
        if(!item.overrideEditing) return;

        var inlist = $filter('filter')($scope.my_bid.overrides, {
            'plan_code': item.item}, true);

        if(inlist.length !== 1) {
            toaster.pop('error', 'Plan Override', 'Problem with the overrides database.');
            return;
        }

        inlist[0].amount = Number(item.bid_overhead_and_profit);
        inlist[0].enabled = true;

        var diff = inlist[0].current_amount - inlist[0].amount;

        item.bid_total -= diff;

        //$scope.buildBidCoverPage();

        $scope.show_spinner = true;
        $scope.my_bid.$update(function(res) {
            toaster.pop('success', 'Bid Database', 'Subtask Updated.');
            $scope.show_spinner = false;
        }, function(error) {
            toaster.pop('error', 'Bid Database', 'Problem saving the subtask data.');
        });

        item.overrideEditing = false;
    };

    $scope.editBidTotal = function (item) {
        var inlist = $filter('filter')($scope.my_bid.overrides, {
            'plan_code': item.item}, true);

        if(inlist.length === 0) {
            //we don't have an entry for this so set it up
            //we will save and do logic later.  we have to
            //do this here so we have the original_amount
            //prior to any user edits
            $scope.my_bid.overrides.push({
                'plan_code': item.item,
                'enabled': false,
                'current_amount': item.bid_overhead_and_profit,
                'original_amount': item.bid_overhead_and_profit,
                'amount': item.bid_overhead_and_profit
            });
        } else if(inlist.length === 1) {
            inlist[0].current_amount = item.bid_overhead_and_profit;
        }

        inlist = $filter('filter')($scope.my_bid.extra_liability, {
            'plan_code': item.item}, true);

        if(inlist.length === 0) {
            //we don't have an entry for this so set it up
            //we will save and do logic later.  we have to
            //do this here so we have the original_amount
            //prior to any user edits
            $scope.my_bid.extra_liability.push({
                'plan_code': item.item,
                'enabled': false,
                'current_amount': item.bid_general_liability,
                'original_amount': item.bid_general_liability,
                'amount': item.bid_general_liability
            });
        } else if(inlist.length === 1) {
            inlist[0].current_amount = item.bid_general_liability;
        }

        item.bidTotalEditing = true;
    };

    $scope.doneBidTotalEditing = function (item) {
        if(!item.bidTotalEditing) return;

        var inlist = $filter('filter')($scope.my_bid.overrides, {
            'plan_code': item.item}, true);

        if(inlist.length !== 1) {
            toaster.pop('error', 'Plan Override', 'Problem with the overrides database.');
            return;
        }

        if(!$scope.my_bid.costs) {
            $scope.my_bid.costs = $scope.company_factors;
        }

        item.bid_general_liability = item.bid_total * $scope.my_bid.costs.general_liability;
        item.bid_overhead_and_profit = item.bid_total - item.bid_general_liability -
            item.bid_total_labor - item.bid_total_materials - item.bid_total_equipment;

        inlist[0].amount = Number(item.bid_overhead_and_profit);
        inlist[0].enabled = true;

        inlist = $filter('filter')($scope.my_bid.extra_liability, {
            'plan_code': item.item}, true);

        if(inlist.length !== 1) {
            toaster.pop('error', 'Plan Override', 'Problem with the bid database.');
            return;
        }

        inlist[0].amount = Number(item.bid_general_liability - inlist[0].original_amount);
        inlist[0].enabled = true;

        $scope.show_spinner = true;
        $scope.my_bid.$update(function(res) {
            toaster.pop('success', 'Bid Database', 'Subtask Updated.');
            $scope.show_spinner = false;
        }, function(error) {
            toaster.pop('error', 'Bid Database', 'Problem saving the subtask data.');
        });

        item.bidTotalEditing = false;
    };

    $scope.editPieceRate = function (item) {
        if(item.piece_per_hour_rate !== 0) {
            alert('You must clear out Piece/Hour Rate first.');
            return;
        }

        item.crewPieceRateEditing = true;
    };

    $scope.donePieceRateEditing = function (item) {
        if(!item.crewPieceRateEditing) return;

        $scope.updateSubtask(item);

        item.crewPieceRateEditing = false;
    };

    $scope.editPiecePerHourRate = function (item) {
        if(item.piece_rate !== 0) {
            alert('You must clear out Piece Rate first.');
            return;
        }

        item.crewPiecePerHourRateEditing = true;
    };

    $scope.donePiecePerHourRateEditing = function (item) {
        if(!item.crewPiecePerHourRateEditing) return;

        $scope.updateSubtask(item);

        item.crewPiecePerHourRateEditing = false;
    };

    $scope.editUnits = function (item) {
        item.unitEditing = true;
    };

    $scope.doneUnitEditing = function (item) {
        if(!item.unitEditing) return;

        item.unit = item.unit.unit;

        $scope.updateSubtask(item);

        item.unitEditing = false;
    };

    $scope.updateTotalMaterial = function (item) {
        $scope.my_bid.overrides = []; //this action removes overrides by the user
        $scope.my_bid.extra_liability = [];

        if(!$scope.my_bid.costs) {
            $scope.my_bid.costs = $scope.company_factors;
        }

        var task = $filter('filter')($scope.my_bid.bid, {
            'plan_code': item.plan_code, 'task_id': item.task_id }, true);

        if(task.length !== 1) {
            toaster.pop('error', 'Problem Getting Task', 'Contact Admin.');
            return;
        }

        var mat = $filter('filter')(task[0].subtasks[item.subtask_id].materials, {
              'material_id': item._id }, true);

        if(mat.length !== 1) {
            toaster.pop('error', 'Problem Getting Material', 'Contact Admin.');
            return;
        }
        mat[0].is_overridden = true;
        mat[0].quantity = mat[0].quantity_allowed = mat[0].overridden_quantity = item.quantity;

        // item.is_overridden = true;
        // item.overridden_quantity = item.quantity_allowed = item.quantity;

        $scope.show_spinner = true;
        $scope.my_bid.$update(function(res) {
            toaster.pop('success', 'Database', 'Database updated');
            $scope.company_factors = res.costs;
            $scope.show_spinner = false;
        }, function(error) {
            toaster.pop('error', 'Database', 'Problem updating the database');
        });
    };

    $scope.updateRateDisplay = function() {
        if($scope.tradeItems._id) {
            if($scope.tradeItems.crew_rate && $scope.tradeItems.equipment_costs &&
                $scope.tradeItems.hours_allowed && $scope.tradeItems.labor_costs &&
                $scope.tradeItems.liability && $scope.tradeItems.markup &&
                $scope.tradeItems.material_costs && $scope.tradeItems.trade_rates &&
                $scope.tradeItems.quantity) {
                $scope.tradeItems.$delete(function(success) {
                    toaster.pop('success', 'Trade Items Updated');
                    $scope.tradeItems = {
                        hours_allowed: true,
                        crew_rate: true,
                        trade_rates: true,
                        labor_costs: true,
                        liability: true,
                        markup: true,
                        material_costs: true,
                        equipment_costs: true,
                        quantity: true
                    }
                }, function(error) {
                    toaster.pop('error', 'Trade Items Error', error);
                });
            } else {
                $scope.show_spinner = true;
                $scope.tradeItems.$update(function(success) {
                    toaster.pop('success', 'Trade Items Updated');
                    $scope.tradeItems = success;
                    $scope.show_spinner = false;
                }, function(error) {
                    toaster.pop('error', 'Trade Items Error', error);
                });
            }
        } else {
            var tradeItems = new TradeItems({
                'company_code': userService.getCompanyCode($scope.user.username),
                'trade_code': $scope.trade_code,
                'bid_id': $scope.bid._id,
                'crew_rate': $scope.tradeItems.crew_rate,
                'equipment_costs': $scope.tradeItems.equipment_costs,
                'hours_allowed': $scope.tradeItems.hours_allowed,
                'labor_costs': $scope.tradeItems.labor_costs,
                'liability': $scope.tradeItems.liability,
                'markup': $scope.tradeItems.markup,
                'material_costs': $scope.tradeItems.material_costs,
                'trade_rates': $scope.tradeItems.trade_rates,
                'quantity': $scope.tradeItems.quantity
            });

            tradeItems.$save(function(success) {
                toaster.pop('success', 'Trade Items Updated');
                $scope.tradeItems = success;
            }, function(error) {
                toaster.pop('error', 'Trade Items Error', error);
            });
        }
    };

    $scope.updateBid = function() {
        $scope.$emit('showBidRequestSpinnerOn');
        $scope.bid.$update(function(success) {
            $scope.bid = success;
            $scope.bid.project_start_date = new Date($scope.bid.project_start_date);
            toaster.pop('success', 'Bid Updated');
            $scope.$emit('showBidRequestSpinnerOff');
        }, function(error) {
            toaster.pop('error', 'Bid Update Error', error);
        })
    };

    $scope.updateTradeBid = function() {
        $scope.$emit('showBidRequestSpinnerOn');
        $scope.my_bid.$update(function(success) {
            $scope.my_bid = success;
            toaster.pop('success', 'Trade Bid Updated');
            $scope.$emit('showBidRequestSpinnerOff');
        }, function(error) {
            toaster.pop('error', 'Trade Bid Update Error', error);
        });
    };

    $scope.cancelFormTitle = function() {
        $scope.my_bid.form_title = this.originalFormTitle;
    };

    $scope.cancelClientTitle = function() {
        $scope.my_bid.client_info_title = this.originalClientTitle;
    };

    $scope.cancelContractorTitle = function() {
        $scope.my_bid.contractor_info_title = this.originalContractorTitle;
    };

    $scope.cancelProposalTitle = function() {
        $scope.my_bid.proposal_title = this.originalProposalTitle;
    };

    $scope.cancelCostTitle = function() {
        $scope.my_bid.cost_breakdown_title = this.originalCostTitle;
    };

    $scope.cancelTermsTitle = function() {
        $scope.my_bid.terms_title = this.originalTermsTitle;
    };

    $scope.cancelInclusionsTitle = function() {
        $scope.my_bid.inclusions_title = this.originalInclusionsTitle;
    };

    $scope.cancelExclusionsTitle = function() {
        $scope.my_bid.exclusions_title = this.originalExclusionsTitle;
    };

    $scope.cancelAcceptanceTitle = function() {
        $scope.my_bid.acceptance_title = this.originalAcceptanceTitle;
    };

    $scope.cancelSubmittedAcceptance = function() {
        $scope.my_bid.submitted_by = this.originalSubmittedAcceptance;
    };

    $scope.cancelSignedAcceptance = function() {
        $scope.my_bid.signed_by = this.originalSignedAcceptance;
    };

    $scope.cancelBuilderName = function() {
        $scope.bid.builder_info.name = this.originalBuilderName;
    };

    $scope.cancelBuilderAddress = function() {
        $scope.bid.builder_info.address_one = this.originalBuilderAddressOne;
        $scope.bid.builder_info.address_two = this.originalBuilderAddressTwo;
    };

    $scope.cancelBuilderCityStateZip = function() {
        $scope.bid.builder_info.city = this.originalBuilderCity;
        $scope.bid.builder_info.state = this.originalBuilderState;
        $scope.bid.builder_info.zip = this.originalBuilderZip;
    };

    $scope.cancelBuilderPhone = function() {
        $scope.bid.builder_info.phone = this.originalBuilderPhone;
    };

    $scope.cancelBuilderEmail = function() {
        $scope.bid.builder_info.email = this.originalBuilderEmail;
    };

    $scope.cancelProjectName = function() {
        $scope.bid.project_name = this.originalProjectName;
    };

    $scope.cancelQuantityEdit = function(index) {
        $scope.cost_breakdowns[index].quantity = this.originalQuantityEdit;
    };

    $scope.moveUp = function(item, $index) {
        console.log(item);
        var temp = $scope.my_bid.sections[$index-1];
        $scope.my_bid.sections[$index-1] = item;
        $scope.my_bid.sections[$index] = temp;
    };

    $scope.moveDown = function(item, $index) {
        console.log(item);
        var temp = $scope.my_bid.sections[$index+1];
        $scope.my_bid.sections[$index+1] = item;
        $scope.my_bid.sections[$index] = temp;
    };

    $scope.getTaskTotal = function(task_id, plan) {
        var value = $filter('filter')(plan.bid_tasks, {'_id': task_id}, true);

        if(value && value.length == 1)
            return value[0].total;
        else
            return 0;
    }

    $scope.printProposal = function() {
        _.each($scope.my_bid.sections, function(section, idx) {
            if(section.label == "Page Break" && idx != 8) {
                $scope.print_options.showPageBreak = true;
            }
        });

        $scope.print_options.selectionOption = this.selectionOption;
        bidProposalPrintService.buildPDF(
            $scope.bid, 
            $scope.my_bid, 
            $scope.my_trade, 
            $scope.cost_breakdowns, 
            $scope.user, 
            $scope.print_options);
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/trades/public/controllers/tradeBidRequestEdit.js